import { render, staticRenderFns } from "./VirtualKeyboardAlice.vue?vue&type=template&id=b5f2d4f6&scoped=true&"
import script from "./VirtualKeyboardAlice.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboardAlice.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboardAlice.vue?vue&type=style&index=0&id=b5f2d4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f2d4f6",
  null
  
)

export default component.exports